'use strict';

angular.module('membership')
  .controller('CustomerCtrl', [
    '$scope', '$state', '$sce', 'customerViewModel', '$stateParams',
    function ($scope, $state, $sce, viewModel, $stateParams) {
      var customerId = parseInt($stateParams.key);
      if ($state.current.name.indexOf('.') == -1) {
        $state.go($state.current.name + '.general', $stateParams);
      }
      $scope.company = { Id: customerId };
      $scope.model = new viewModel($scope.company);

      $scope.getGoogleMapUrl = function (name, address, isAddressAlreadyCombined) {
        if (isAddressAlreadyCombined) {
          return $sce.trustAsResourceUrl(
            "https://www.google.com/maps/embed/v1/place?q=" + address.replace(",", "").replace(" ", "") + "&key=AIzaSyBcAaO3YFFEbWPgvGgC1rXj9yAmGajPRVA"
          );
        } else {
          return $sce.trustAsResourceUrl(
            "https://www.google.com/maps/embed/v1/place?q=" + address.Street + address.City + address.ZipCode + "&key=AIzaSyBcAaO3YFFEbWPgvGgC1rXj9yAmGajPRVA"
          );
        }
      };

      $scope.getLocalTime = function (timezoneOffset, timezoneName) {
          const now = new Date();

          const utc = now.getTime() + now.getTimezoneOffset() * 60000;
          const localTime = new Date(utc + timezoneOffset * 3600000);

          const timeStr = localTime.toLocaleTimeString('en-US', {
              hour: '2-digit',
              minute: '2-digit',
              hour12: true
          });

          const sign = timezoneOffset >= 0 ? '+' : '-';
          const absOffset = Math.abs(timezoneOffset);
          const offsetH = Math.floor(absOffset).toString().padStart(2, '0');
          const offsetM = Math.round((absOffset - Math.floor(absOffset)) * 60).toString().padStart(2, '0');
          const offsetStr = `${sign}${offsetH}:${offsetM}`;

          return `${timeStr} (${timezoneName}, ${offsetStr})`;
      };
    }
]);
